module.exports = __webpack_public_path__ + "img/reduce.fea69ec4.svg";